import { render, staticRenderFns } from "./PersonLeave.vue?vue&type=template&id=61a7290c"
import script from "./PersonLeave.vue?vue&type=script&lang=js"
export * from "./PersonLeave.vue?vue&type=script&lang=js"
import style0 from "./PersonLeave.vue?vue&type=style&index=0&id=61a7290c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports